<div class="cont-switch col-12 {clases}">
      <label
            class="flex-center-v switch"
            style="--switch-height: {h}px; --switch-color: {color} ; {style}"
      >
            <input type="checkbox" bind:checked={value} />
            <span class="slider round"></span>
      </label>
</div>

<script>
      export let value = false; // Estado del switch (on/off)
      export let h = 23; // Altura del switch en píxeles
      export let color = "#7f56da"; // Color del switch cuando está activado
      export let clases = ""; // Color del switch cuando está activado
      export let style = ""; // Color del switch cuando está activado
</script>

<style>
      /* Contenedor del switch */
      .cont-switch {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 12px;
      }

      .cont-texto {
            font-size: 14px;
            /* padding-left: 10px; */
      }

      .pointer {
            cursor: pointer;
      }

      /* Estilos del switch */
      .switch {
            position: relative;
            display: inline-block;
            width: calc(var(--switch-height, 34px) * 1.76); /* Proporción 60x34 por defecto */
            height: var(--switch-height, 34px);
      }

      .switch input {
            opacity: 0;
            width: 0;
            height: 0;
      }

      .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            -webkit-transition: 0.4s;
            transition: 0.4s;
            border-radius: calc(var(--switch-height, 34px) / 2);
      }

      .slider:before {
            position: absolute;
            content: "";
            height: calc(var(--switch-height, 34px) * 0.76);
            width: calc(var(--switch-height, 34px) * 0.76);
            left: calc(var(--switch-height, 34px) * 0.12);
            bottom: calc(var(--switch-height, 34px) * 0.12);
            background-color: white;
            -webkit-transition: 0.4s;
            transition: 0.4s;
            border-radius: 50%;
      }

      input:checked + .slider {
            background-color: var(--switch-color, #2196f3);
      }

      input:focus + .slider {
            box-shadow: 0 0 1px var(--switch-color, #2196f3);
      }

      input:checked + .slider:before {
            -webkit-transform: translateX(calc(var(--switch-height, 34px) * 0.76));
            -ms-transform: translateX(calc(var(--switch-height, 34px) * 0.76));
            transform: translateX(calc(var(--switch-height, 34px) * 0.76));
      }

      /* Redondear el switch */
      .slider.round {
            border-radius: calc(var(--switch-height, 34px) / 2);
      }
</style>
